import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons/faStar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import {
  Rating as ReactRating,
  RatingProps as ReactRatingProps,
} from "react-simple-star-rating";

export interface RatingProps extends ReactRatingProps {
  iconClass?: string;
  fillIconColor?: string;
  emptyIconColor?: string;
  initialValue?: number; // Allow initial value from parent component
  onChange?: (value: number) => void; // Callback to handle changes from the parent
}

const Rating = ({
  iconClass,
  fillIconColor = "warning",
  emptyIconColor = "warning-300",
  initialValue = 0,
  onChange,
  ...rest
}: RatingProps) => {
  return (
    <ReactRating
      initialValue={initialValue} // Use initialValue passed from parent
      onClick={onChange} // Trigger onChange callback when user clicks a star
      allowFraction
      fillIcon={
        <FontAwesomeIcon
          icon={faStar}
          className={classNames(iconClass, `text-${fillIconColor}`)}
        />
      }
      emptyIcon={
        <FontAwesomeIcon
          icon={farStar}
          className={classNames(iconClass, `text-${emptyIconColor}`)}
        />
      }
      {...rest}
    />
  );
};

export default Rating;
